@if (bufferTransactionHistory?.length > 0) {
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h2 class="m-0">{{ 'settlementaccount.buffer_history' | translate }}</h2>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div>
        @if (isLoading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }

        <table mat-table [dataSource]="bufferHistoryDataSource" class="w-full">
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>{{ 'settlementaccount.history_date' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label mr-16">{{ 'settlementaccount.history_date' | translate }}: </span
              ><span>{{ element.transactionDate | date: 'shortDate' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>{{ 'settlementaccount.history_type' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label mr-16">{{ 'settlementaccount.history_type' | translate }}: </span>
              <span>{{ element.transactionType }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>{{ 'settlementaccount.history_amount' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label mr-16">{{ 'settlementaccount.history_amount' | translate }}: </span
              ><span>{{ element.amount.toString() | price: 'fraction' : currencyCode }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="previousBalance">
            <th mat-header-cell *matHeaderCellDef>{{ 'settlementaccount.history_previous-balance' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label mr-16">{{ 'settlementaccount.history_previous-balance' | translate }}: </span>
              <span>{{ element.previousBalance.toString() | price: 'fraction' : currencyCode }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="newBalance">
            <th mat-header-cell *matHeaderCellDef>{{ 'settlementaccount.history_new-balance' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label mr-16">{{ 'settlementaccount.history_new-balance' | translate }}: </span>
              <span>{{ element.newBalance.toString() | price: 'fraction' : currencyCode }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="reference">
            <th mat-header-cell *matHeaderCellDef>{{ 'settlementaccount.history_reference' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label mr-16">{{ 'settlementaccount.history_reference' | translate }}: </span>
              <span>{{ element.reference }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element">
              <a color="primary" [href]="element.pdfUrl" target="_blank">
                <span class="text-3xl"><i class="fa-solid fa-file-pdf"></i></span
              ></a>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="DISPLAYED_COLUMNS"></tr>
          <tr mat-row *matRowDef="let row; columns: DISPLAYED_COLUMNS"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            @if (!isLoading) {
              <td class="mat-cell" colspan="4">{{ 'communication.no_records' | translate }}</td>
            }
          </tr>
        </table>

        <mat-paginator
          #paginator
          (page)="getPaginatorData($event)"
          [pageSize]="pageSize"
          [pageIndex]="pageNumber - 1"
          [pageSizeOptions]="pageSizeOptions"
          showFirstLastButtons>
        </mat-paginator>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
}
